import { render, staticRenderFns } from "./ProjectItems.vue?vue&type=template&id=3cd5c8e0&scoped=true"
import script from "./ProjectItems.vue?vue&type=script&lang=js"
export * from "./ProjectItems.vue?vue&type=script&lang=js"
import style0 from "./ProjectItems.vue?vue&type=style&index=0&id=3cd5c8e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5c8e0",
  null
  
)

export default component.exports